import { Controller } from "stimulus"
import { tns } from "tiny-slider/src/tiny-slider"

// Category carousels on the blog (index and article pages).
// This used to be an inline $(document).on(...) script in each view, which never
// ran for logged-out visitors: the layout defers jQuery for them, so $ did not
// exist yet when the inline script executed.
//
// The controller sits on the wrapper, not on each .my-slider, because tns()
// moves its container into new wrapper divs; moving a controller's own element
// would make Stimulus disconnect and reconnect it.
export default class extends Controller {
  static targets = ["slider"]

  connect() {
    this.sliders = this.sliderTargets.map((container) => tns({
      container: container,
      responsive: {
        200: {
          items: 2.5,
          gutter: 20,
          controls: false,
          mouseDrag: true,
          touch: true
        },
        576: {
          items: 5,
          gutter: 32,
          controls: true,
          controlsText: ["<", ">"]
        }
      },
      slideBy: "page",
      loop: false
    }))

    // Undo the markup before the page snapshot is cached, otherwise a page
    // restored with the back button gets wrapped a second time.
    this.destroyHandler = this.destroy.bind(this)
    document.addEventListener("turbolinks:before-cache", this.destroyHandler)
    document.addEventListener("turbo:before-cache", this.destroyHandler)
  }

  disconnect() {
    document.removeEventListener("turbolinks:before-cache", this.destroyHandler)
    document.removeEventListener("turbo:before-cache", this.destroyHandler)
    this.destroy()
  }

  destroy() {
    this.sliders.forEach((slider) => slider.destroy())
    this.sliders = []
  }
}
